if (!customElements.get('mega-menu-preview')) {
  customElements.define(
    'mega-menu-preview',
    class MegaMenuPreview extends HTMLElement {
      constructor() {
        super();
        this.images = this.querySelectorAll('.mega-menu__preview-image');
        this.titleEl = this.querySelector('.mega-menu__preview-title');
        this.linkEl = this.querySelector('.mega-menu__preview-media');
        this.activeIndex = 0;
        this.currentSrc = this.images.length ? this.images[0].getAttribute('src') : null;

        this.querySelectorAll('[data-preview-image]').forEach((link) => {
          const { previewImage, previewTitle, previewUrl } = link.dataset;
          link.addEventListener('mouseenter', () => this.show(previewImage, previewTitle, previewUrl));
          link.addEventListener('focus', () => this.show(previewImage, previewTitle, previewUrl));
        });
      }

      show(src, title, url) {
        if (!src || src === this.currentSrc) return;
        this.currentSrc = src;

        const next = this.images[1 - this.activeIndex];
        next.addEventListener(
          'load',
          () => {
            this.images.forEach((image) => image.classList.remove('is-active'));
            next.classList.add('is-active');
          },
          { once: true }
        );
        next.src = src;
        this.activeIndex = 1 - this.activeIndex;

        if (this.titleEl && title) this.titleEl.textContent = title;
        if (this.linkEl && url) this.linkEl.setAttribute('href', url);
      }
    }
  );
}
